import axios from 'axios'
import { toast } from 'react-toastify'

const api = "https://api.jawanpakistan.com/";
// const api = "http://localhost:5000/";

const getAllCourseList = () => (dispatch) => {
    dispatch({type:"GET_ALL_COURSE_LIST_REQUEST"})

    axios.get(`${api}courseList/getAllCourseList`).then((res) => {
        dispatch({type:"GET_ALL_COURSE_LIST_SUCCESS",payload:res.data.data})
        console.log(res.data,'resssss')
    }).catch((err) => {
        dispatch({type:"GET_ALL_COURSE_LIST_FAIL",payload:err.message})
    })
}

const addtoCourseList = (courseName,courseCode,showmodal) => (dispatch) => {
    dispatch({type:"ADD_TO_COURSE_LIST_REQUEST"})

    const obj = {
        courseName:courseName,
        courseCode:courseCode
    }

    const options = {
      method: "POST",
      headers: { Accept: "application/json" },
      data: obj,
      // url: `http://localhost:5000/registration/addCourseAnoouce`,
      url: `${api}courseList/addtoCourseList`,
    }

    axios(options).then((response) => {
        dispatch({type:"ADD_TO_COURSE_LIST_SUCCESS",payload:response.data.data})
        showmodal(false)
        dispatch(getAllCourseList())
        toast.success(response.data.message)
    }).catch((err) => {
        dispatch({type:"ADD_TO_COURSE_LIST_FAIL",payload:err.message})

        toast.error(err.message)
    })
}

const deletefromcourseList = (id) => (dispatch) => {
    dispatch({type:"DELETE_FROM_COURSE_LIST_REQUEST"})

    const options = {
        method: "DELETE",
        headers: { Accept: "application/json" },
        url: `${api}courseList/deletefromcourseList/${id}`,
    }

    axios(options).then((response) => {
        dispatch({type:"DELETE_FROM_COURSE_LIST_SUCCESS",payload:response.data})
        dispatch(getAllCourseList())
        toast.success(response.data.message)
    }).catch((err) => {
        console.log(err)
        dispatch({type:"DELETE_FROM_COURSE_LIST_FAIL",payload:err.message})

        toast.error(err.message)
    })
}

export { getAllCourseList, addtoCourseList, deletefromcourseList }